import React, { useEffect } from "react";
import splasIm from "../../../assets/images/Splash-man.png";
import { useNavigate } from "react-router-dom";

function AdminSplash() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/EmployeeLogin");
    }, 2000);
  }, []);
  return (
    <>
      <div className="splashMainDiv" onClick={() => navigate("/EmployeeLogin")}>
        <img src={splasIm} />
        <h1>ToDoBoom</h1>
        <p>Stay on top of your to-do list.</p>
      </div>
    </>
  );
}

export default AdminSplash;
